import {ISelectValues} from "../../../component/ISelectValues";

const BLUE = "secondary.transparent";
const PINK = "accent.transparent";
const YELLOW = "warning.transparent";
const GREY = "neutral.light";
const GREEN = "success.transparent";
const RED = "error.transparent";

export const ID_FILTER_CUSTOMER = "customer";
export const ID_FILTER_STATUS = "status";
export const ID_FILTER_EXPIRATION_DATE_FROM = "expirationDateFrom";
export const ID_FILTER_EXPIRATION_DATE_TO = "expirationDateTo";
export const ID_FILTER_NETWORK_CODE = "networkCode";
export const ID_FILTER_PAN = "pan";
export const ID_FILTER_PAN_ALIAS = "panAlias";
export const ID_FILTER_PAN_ALIAS_CUSTOMER = "panAliasCustomer";
export const ID_FILTER_LEGAL_ENTITIES = 'legal-entities';
export const ID_FILTER_DEALERS = 'dealers'

export const STATUS_READY = "READY";
export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_REVOKED = "REVOKED";

export const NETWORK_CODE: ISelectValues[] = [
    {
        value: "06",
        label: "types.networkcode.PAN"
    },
    {
        value: "95",
        label: "types.networkcode.CUSTOMER_PAN_ALIAS"
    },
    {
        value: "98",
        label: "types.networkcode.PAN_ALIAS"
    }
];

export const CARD_STATUSES: ISelectValues[] = [
    {
        value: "READY",
        label: "types.statuses.READY",
        color: BLUE,
    },
    {
        value: "ACTIVE",
        label: "types.statuses.ACTIVE",
        color: GREEN,
    },
    {
        value: "REVOKED",
        label: "types.statuses.REVOKED",
        color: RED,
    }
];

export const convertTypology = (type: ISelectValues[], value: string) => {
    const item = type.find((item) => item.value === value);
    return item ? item.label : value;
}

export const cardDefaultValues = {
    [ID_FILTER_CUSTOMER]: "",
    [ID_FILTER_NETWORK_CODE]: [],
    [ID_FILTER_STATUS]: [],
    [ID_FILTER_EXPIRATION_DATE_FROM]: null,
    [ID_FILTER_EXPIRATION_DATE_TO]: null,
    dealers: []
};
